import { render, staticRenderFns } from "./SafeProjectDetails.vue?vue&type=template&id=32008ce0&scoped=true&"
import script from "./SafeProjectDetails.vue?vue&type=script&lang=js&"
export * from "./SafeProjectDetails.vue?vue&type=script&lang=js&"
import style0 from "./SafeProjectDetails.vue?vue&type=style&index=0&id=32008ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32008ce0",
  null
  
)

export default component.exports